/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */

export type Themes = typeof Themes[keyof typeof Themes];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Themes = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
} as const;
